import { createContext, useContext } from "react";

const ExpiredContext = createContext(false);

export const ExpiredProvider = ExpiredContext.Provider;

export const useExpired = () => useContext(ExpiredContext);
